import { isFunc } from 'utils/type-checker';

export type HttpHeader = Headers;
export type HttpMethod = 'POST' | 'PUT' | 'PATCH' | 'GET';
export type HttpBody = BodyInit;
export type HttpConfig = {
  headers?: HttpHeader;
  method?: HttpMethod;
  body?: HttpBody;
};

class Http {
  private static config: HttpConfig = {};

  /**
   * @return {Http}
   */
  public static headers(init: HeadersInit) {
    Http.config.headers = new Headers(init);
    return Http;
  }

  /**
   * @return {Http}
   */
  public static method(method: HttpMethod) {
    Http.config.method = method;
    return Http;
  }

  /**
   * @return {Http}
   */
  public static body(body: BodyInit) {
    Http.config.body = body;
    return Http;
  }

  /**
   * @return {Http}
   */
  public static dump() {
    console.log(Http.config);
    return Http.config;
  }

  /**
   * @param {String} URl
   * @param {Function} formatter
   * @return {Promise}
   */
  public static send(url: string, formatter?: () => {}): Promise<any> {
    if (Http.config.headers?.get('Content-Type') === null) {
      Http.config.headers?.set('Content-Type', 'application/json');
    }

    if (isFunc(formatter) && formatter?.name === 'toJSON') {
      return fetch(url, Http.config).then(formatter);
    }

    return fetch(url, Http.config);
  }

  /**
   * @param {Response} response
   * @return {Promise}
   */
  public static toJSON(response: Response) {
    return response.json();
  }

  /**
   * @param {String} token
   * @return {Http}
   */
  public static bearer(token: string) {
    Http.config.headers?.set('Authorization', `Bearer ${token}`);
    return Http;
  }
}

export default Http;
